const Minus = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="11" width="16" height="2" fill="#181818"/>
    </svg>
)

export default Minus
